import React, { ForwardedRef, forwardRef } from "react";

import { PortableTextBlock } from "@portabletext/types";
import clsx from "clsx";

import Carousel, { NextButton, PrevButton, StepRendererProps } from "components/carousel";
import carouselStyles from "components/carousel/index.module.css";
import { CarouselProvider } from "components/carousel/use-carousel";
import HeroSection from "components/hero-section";
import RichPortableText from "components/rich-text";

export type Testimonial = {
  comment: PortableTextBlock;
  author: string;
  company: string;
};

const StepRenderer = forwardRef<HTMLDivElement, StepRendererProps>(
  ({ step, className }: StepRendererProps, ref: ForwardedRef<HTMLDivElement> | undefined) => (
    <div className={clsx(className, "inline-block p-4 md:p-6 bg-white shadow-md rounded-md")} ref={ref}>
      <blockquote>
        <RichPortableText value={step.comment} />
        <footer className="text-primary mt-2">
          <p>
            - {step.author}, {step.company}
          </p>
        </footer>
      </blockquote>
    </div>
  )
);
StepRenderer.displayName = "StepRenderer";

type TestimonialsProps = { testimonials: Testimonial[] };
const Testimonials = ({ testimonials }: TestimonialsProps) => (
  <CarouselProvider steps={testimonials} infinite autoPlayDuration={5000}>
    <div className="bg-navy-dark">
      <HeroSection>
        <HeroSection.Content className="min-w-0">
          <div className="flex flex-col items-center justify-center space-y-4 md:space-y-0 md:space-x-6 md:flex-row">
            <PrevButton className={clsx(carouselStyles.carouselButtonWhite, "!hidden md:!flex")} />
            <div className="sm:w-2/3 md:w-3/5 xl:w-1/2 max-w-full">
              <Carousel StepRenderer={StepRenderer} />
            </div>
            <NextButton className={clsx(carouselStyles.carouselButtonWhite, "!hidden md:!flex")} />
            <div className="flex space-x-6">
              <PrevButton className={clsx(carouselStyles.carouselButtonWhite, "md:!hidden")} />
              <NextButton className={clsx(carouselStyles.carouselButtonWhite, "md:!hidden")} />
            </div>
          </div>
        </HeroSection.Content>
      </HeroSection>
    </div>
  </CarouselProvider>
);

export default Testimonials;
